import { icon } from './icons';

export function footerHTML(): string {
  return `
    <footer class="footer">
      <div class="footer-grid">
        <div class="footer-brand">
          <a href="#/" class="logo-text" aria-label="StonkRider — home"><span>STONK</span><span>RIDER</span></a>
          <p>Real market &amp; revenue data turned into motocross tracks you can ride.</p>
          <div class="footer-socials">
            <a href="https://x.com/ooopsideployed" target="_blank" rel="noopener" class="footer-social" aria-label="Follow on X">${icon('logo-twitter', 14)}</a>
            <a href="https://www.linkedin.com/in/aymeric-dietrich-a5a477a3/" target="_blank" rel="noopener" class="footer-social" aria-label="LinkedIn">${icon('logo-linkedin', 14)}</a>
            <a href="https://ko-fi.com/oopsideployed" target="_blank" rel="noopener" class="footer-social" aria-label="Buy me a coffee on Ko-fi">${icon('cafe', 15)}</a>
          </div>
        </div>
        <nav class="footer-col" aria-label="Play">
          <div class="footer-col-title">Play</div>
          <ul>
            <li><a href="#/">Stock charts</a></li>
            <li><a href="#/startups">Startup revenue</a></li>
            <li><a href="#/leaderboard">Daily challenge &amp; leaderboard</a></li>
            <li><a href="#/early-access">Global markets — early access</a></li>
          </ul>
        </nav>
        <nav class="footer-col" aria-label="Company">
          <div class="footer-col-title">Company</div>
          <ul>
            <li><a href="#/about">About StonkRider</a></li>
            <li><a href="#/contact">Contact</a></li>
            <li><a href="#/privacy">Privacy</a></li>
            <li><a href="#/terms">Terms</a></li>
            <li><a href="#/legal">Legal</a></li>
          </ul>
        </nav>
      </div>
      <div class="footer-note">Built with real market &amp; revenue data · Not financial advice</div>
    </footer>
  `;
}
